<article class="card-shell">
  <header class="card-header">
    <div>
      <h3 class="card-title">{{ title }}</h3>
      @if (subtitle) {
        <p class="card-subtitle">{{ subtitle }}</p>
      }
    </div>

    @if (badge) {
      <span class="card-badge">{{ badge }}</span>
    }
  </header>

  <section class="card-content">
    <ng-content></ng-content>
  </section>

  @if (actionLabel) {
    <footer class="card-footer">
      <button type="button" class="wm-button-secondary" (click)="onAction()">
        {{ actionLabel }}
      </button>
    </footer>
  }
</article>
